import Firebase from 'firebase'
// Required for side-effects
require("firebase/firestore");

import firebaseConfig from '@/config/firebase.env';
export const firebase = Firebase.initializeApp(firebaseConfig);

// Initialize Cloud Firestore through Firebase
export const db = firebase.firestore();
